import { Component } from '@angular/core';

/** Root component. */
@Component({
  selector: 'saanbow-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {}
